import { render } from "./ChannelXaccelStreams.vue?vue&type=template&id=18a3d288"
import script from "./ChannelXaccelStreams.vue?vue&type=script&lang=js"
export * from "./ChannelXaccelStreams.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__